export const PRIMARY_COLOR: string = '#d50215'

export const VARIABLE_UNKNOWN_VALUE = '$NA'
